import React from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Typography } from '@chilecompra/react-kit/components'
import { PUBLIC_URL } from '../../config/settings/environment'
import { Column, ManualLogo, Row } from './HomeForm.styles'
import { useViewport } from '@chilecompra/react-kit'

/**
 * The GoodPractices's component.
 */
const GoodPractices = props => {
  const { onOpenPDFManual } = props
  const {
    size: { isDownToMedium }
  } = useViewport()

  return (
    <Row columnSpacing={{ md: 5 }} rowSpacing={5}>
      <Column xs={12}>
        <Card color="blank">
          <Row justifyContent={isDownToMedium ? 'center' : 'flex-start'}>
            <Column md={1}>
              <ManualLogo alt="Manual" src={`${PUBLIC_URL}/assets/images/img_manual.svg`} />
            </Column>
            <Column md={9}>
              <Typography fontWeight="bold" sx={{ mb: 1 }} variant="h3">
                Política de compra de pasajes
              </Typography>
              <Typography variant="body1">
                Esta política se ha confeccionado sobre la base de las directrices vigentes por la Dirección de
                Presupuestos respecto de la adquisición de tickets aéreos para vuelos nacionales.
              </Typography>
            </Column>
            <Column md={2}>
              <Button margin="16px 0" onClick={onOpenPDFManual}>
                Ver documento
              </Button>
            </Column>
          </Row>
        </Card>
      </Column>
    </Row>
  )
}

GoodPractices.propTypes = {
  onOpenPDFManual: PropTypes.func.isRequired
}

export default GoodPractices
